module.exports = __webpack_public_path__ + "static/media/111.0ff9ddca.png";